// Starts the database resuming as soon as an app opens (it pauses after 10
// minutes idle, ADR 0007), so it's ready by the time someone has signed in.
// Fire and forget: no token, no answer awaited, every failure ignored. A plain
// GET with no custom headers, so the browser sends no preflight.
export function wakeDatabase(apiUrl: string, doFetch: typeof fetch = fetch.bind(globalThis)): void {
  try {
    void doFetch(`${apiUrl}/v1/wake`, { keepalive: true }).catch(() => undefined);
  } catch {
    // Nothing to do: the first real request wakes it instead.
  }
}
